<div class="wrapper">
    <img class="loading" src="assets/images/loader/animation.gif" alt="Loading" />
</div>
